import React from 'react';

const RefundPolicy = () => {
  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
      <h2 style={{ textAlign: 'center', color: '#333' }}>Refund Policy</h2>
      <p style={{ textAlign: 'center', color: '#555' }}>
      we dont provide refund or return
      </p>
    </div>
  );
};

export default RefundPolicy;
